import API from '../../../global/api';
import {getUsers} from '../dashboard/dashboard.actions'


//Action types
export const DELETE_USER= 'DELETE_USER';
export const SELECTED_USER= 'SELECTED_USER';
export const DELETE_USER_SUCCESS= 'DELETE_USER_SUCCESS';
export const UPDATE_USER_SUCCESS= 'UPDATE_USER_SUCCESS';
export const ADD_USER_SUCCESS= 'ADD_USER_SUCCESS';




// Request Actions
export const addUserSuccess = (data) =>( {
  type : ADD_USER_SUCCESS,
  data: data
});

const deleteUserSuccess = (id) =>( {
  type : DELETE_USER_SUCCESS,
  id : id
});

const UpdateUserSuccess = () =>( {
  type : UPDATE_USER_SUCCESS,
  // data : data
});

export const selectedUser= (data) =>( {  
  type : SELECTED_USER,
  data: data,
});


//Api calls
export const deleteUser= (id) => {
    return dispatch => {
    API.post(`/users/delete-user`,{
      id: id
    }, {
    headers : {
      "Authorization" : `Bearer ${window.localStorage.getItem('auth_id')}`
    }
  })
  .then(res => {
      dispatch(getUsers());
      dispatch(deleteUserSuccess(id))
  })
}
};

export const updateUser= (data, oldData) => {
  return dispatch => {
  API.put(`/users/update-user`,
   {
  id: oldData.user_id, 
  email: data.email,
  password: data.password,
  lastName: data.last_name,
  firstName: data.first_name,
  city: data.city,
  phone:data.phone,
  userPackage: data.user_package_id
  }, {
  headers : {
    "Authorization" : `Bearer ${window.localStorage.getItem('auth_id')}`
  }, 
})
.then(res => {
    dispatch(getUsers());
    dispatch(UpdateUserSuccess())
})
}
};



export const addUser = (data) => {
  console.log(data,"ttqqqqqq")
  return dispatch => {
    API.post(`users/user-register`,
      {
        firstName:data.first_name,
        lastName:data.last_name,
        city : data.city,
        password:data.password,
        email: data.email, 
        phone : data.phone,
        userPackage: data.user_package_id,
      }, {
      headers: {
        "Authorization": `Bearer ${window.localStorage.getItem('auth_id')}`
      }
    })
      .then(res => {
        dispatch(getUsers());
      })
  }
};